import { resolveComponent as _resolveComponent, createVNode as _createVNode, createCommentVNode as _createCommentVNode, withCtx as _withCtx, normalizeProps as _normalizeProps, guardReactiveProps as _guardReactiveProps, createElementVNode as _createElementVNode, withModifiers as _withModifiers, createTextVNode as _createTextVNode, toDisplayString as _toDisplayString, mergeProps as _mergeProps, withKeys as _withKeys, openBlock as _openBlock, createBlock as _createBlock } from "vue";
const _hoisted_1 = { class: "dialog-wrapper" };
const _hoisted_2 = { class: "grey lighten-5 px-4 py-4" };
const _hoisted_3 = { class: "require-field-wrapper pa-4" };
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_DialogHeader = _resolveComponent("DialogHeader");
    const _component_v_text_field = _resolveComponent("v-text-field");
    const _component_InputRow = _resolveComponent("InputRow");
    const _component_vue_datepicker_action_row = _resolveComponent("vue-datepicker-action-row");
    const _component_vue_datepicker = _resolveComponent("vue-datepicker");
    const _component_v_autocomplete = _resolveComponent("v-autocomplete");
    const _component_v_col = _resolveComponent("v-col");
    const _component_v_row = _resolveComponent("v-row");
    const _component_v_form = _resolveComponent("v-form");
    const _component_v_divider = _resolveComponent("v-divider");
    const _component_DialogFooter = _resolveComponent("DialogFooter");
    const _component_v_icon = _resolveComponent("v-icon");
    const _component_v_btn = _resolveComponent("v-btn");
    const _component_v_dialog = _resolveComponent("v-dialog");
    return (_openBlock(), _createBlock(_component_v_dialog, {
        modelValue: _ctx.dialog,
        "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event) => ((_ctx.dialog) = $event)),
        "content-class": "responsive-dialog",
        "onClick:outside": _ctx.handleClickCancel,
        onKeydown: _withKeys(_ctx.handleClickCancel, ["esc"])
    }, {
        activator: _withCtx(({ props }) => [
            _createVNode(_component_v_btn, _mergeProps(props, {
                variant: "outlined",
                block: "",
                class: "add-option-btn",
                disabled: !_ctx.getterSelectedWorkerCashAutoDeductGroupId,
                onClick: _ctx.handleClickOpenDialogBtn
            }), {
                default: _withCtx(() => [
                    _createVNode(_component_v_icon, { small: "" }, {
                        default: _withCtx(() => _cache[13] || (_cache[13] = [
                            _createTextVNode(" mdi-plus ")
                        ])),
                        _: 1 /* STABLE */,
                        __: [13]
                    }),
                    _createTextVNode(" " + _toDisplayString(_ctx.$t(`${_ctx.lc}schedule_dialog.add_title`)), 1 /* TEXT */)
                ]),
                _: 2 /* DYNAMIC */
            }, 1040 /* FULL_PROPS, DYNAMIC_SLOTS */, ["disabled", "onClick"])
        ]),
        default: _withCtx(() => [
            _createElementVNode("div", _hoisted_1, [
                _createVNode(_component_DialogHeader, {
                    title: _ctx.$t(`${_ctx.lc}schedule_dialog.add_title`),
                    "on-cancel": _ctx.handleClickCancel
                }, null, 8 /* PROPS */, ["title", "on-cancel"]),
                _createVNode(_component_v_form, {
                    ref: "formRef",
                    modelValue: _ctx.formValid,
                    "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event) => ((_ctx.formValid) = $event)),
                    onSubmit: _withModifiers(_ctx.handleSubmitForm, ["prevent"])
                }, {
                    default: _withCtx(() => [
                        _createElementVNode("div", _hoisted_2, [
                            _createElementVNode("div", _hoisted_3, [
                                _createCommentVNode(" 스케줄명 "),
                                _createVNode(_component_InputRow, {
                                    label: _ctx.$t(`${_ctx.tableLc}schedule_name`),
                                    "is-required": "",
                                    "is-vertical-label": ""
                                }, {
                                    default: _withCtx(() => [
                                        _createVNode(_component_v_text_field, {
                                            modelValue: _ctx.scheduleName,
                                            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => ((_ctx.scheduleName) = $event)),
                                            variant: "outlined",
                                            dense: "",
                                            "hide-details": "auto",
                                            "validate-on": "blur",
                                            "single-line": "",
                                            placeholder: _ctx.$t('common.input_field_placeholder', { field: '이름' }),
                                            rules: _ctx.formRules.scheduleName,
                                            maxlength: _ctx.CASH_AUTO_DEDUCT_GROUP_SCHEDULE_NAME_MAX_LENGTH,
                                            onBlur: _ctx.onBlurScheduleNameField
                                        }, null, 8 /* PROPS */, ["modelValue", "placeholder", "rules", "maxlength", "onBlur"])
                                    ]),
                                    _: 1 /* STABLE */
                                }, 8 /* PROPS */, ["label"]),
                                _createCommentVNode(" 적용 기간 "),
                                _createVNode(_component_InputRow, {
                                    label: _ctx.$t(`${_ctx.tableLc}period`),
                                    "is-required": "",
                                    "is-vertical-label": ""
                                }, {
                                    default: _withCtx(() => [
                                        _createCommentVNode(" 달력 "),
                                        _createVNode(_component_vue_datepicker, {
                                            modelValue: _ctx.period,
                                            "onUpdate:modelValue": [
                                                _cache[2] || (_cache[2] = ($event) => ((_ctx.period) = $event)),
                                                _ctx.handleClickPeriodDatePickerSubmit
                                            ],
                                            position: "left",
                                            range: "",
                                            teleport: false,
                                            "model-type": "yyyy-MM-dd",
                                            format: "yyyy-MM-dd",
                                            class: "block"
                                        }, {
                                            "action-row": _withCtx((props) => [
                                                _createVNode(_component_vue_datepicker_action_row, _normalizeProps(_guardReactiveProps(props)), null, 16 /* FULL_PROPS */)
                                            ]),
                                            "dp-input": _withCtx(() => [
                                                _createVNode(_component_v_text_field, {
                                                    modelValue: _ctx.periodComputed,
                                                    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event) => ((_ctx.periodComputed) = $event)),
                                                    variant: "outlined",
                                                    density: "compact",
                                                    "prepend-inner-icon": "mdi-calendar-month",
                                                    readonly: "",
                                                    placeholder: _ctx.$t('common.select_field_placeholder', { field: '기간' }),
                                                    "hide-details": "auto",
                                                    rules: _ctx.formRules.period
                                                }, null, 8 /* PROPS */, ["modelValue", "placeholder", "rules"])
                                            ]),
                                            _: 1 /* STABLE */
                                        }, 8 /* PROPS */, ["modelValue", "onUpdate:modelValue"])
                                    ]),
                                    _: 1 /* STABLE */
                                }, 8 /* PROPS */, ["label"]),
                                _createCommentVNode(" 시간 "),
                                _createVNode(_component_InputRow, {
                                    label: _ctx.$t(`${_ctx.tableLc}schedule_type`),
                                    "is-required": "",
                                    "is-vertical-label": ""
                                }, {
                                    default: _withCtx(() => [
                                        _createVNode(_component_v_autocomplete, {
                                            "item-title": "text",
                                            "item-value": "value",
                                            modelValue: _ctx.scheduleType,
                                            "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event) => ((_ctx.scheduleType) = $event)),
                                            items: _ctx.scheduleTypeOptions,
                                            variant: "outlined",
                                            "hide-details": "auto",
                                            rules: _ctx.formRules.scheduleType,
                                            placeholder: _ctx.$t('common.select_field_placeholder', { field: '시간' }),
                                            onKeyup: _cache[4] || (_cache[4] = ($event) => ($event.stopPropagation()))
                                        }, null, 8 /* PROPS */, ["modelValue", "items", "rules", "placeholder"])
                                    ]),
                                    _: 1 /* STABLE */
                                }, 8 /* PROPS */, ["label"]),
                                _createCommentVNode(" 항목 "),
                                _createVNode(_component_InputRow, {
                                    label: _ctx.$t(`${_ctx.tableLc}account_by_worker`),
                                    "is-required": "",
                                    "is-vertical-label": ""
                                }, {
                                    default: _withCtx(() => [
                                        _createVNode(_component_v_autocomplete, {
                                            "item-title": "text",
                                            "item-value": "value",
                                            modelValue: _ctx.accountByWorker,
                                            "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event) => ((_ctx.accountByWorker) = $event)),
                                            items: _ctx.accountByWorkerOptions,
                                            variant: "outlined",
                                            "hide-details": "auto",
                                            rules: _ctx.formRules.accountByWorker,
                                            placeholder: _ctx.$t('common.select_field_placeholder', { field: '항목' }),
                                            onKeyup: _cache[6] || (_cache[6] = ($event) => ($event.stopPropagation()))
                                        }, null, 8 /* PROPS */, ["modelValue", "items", "rules", "placeholder"])
                                    ]),
                                    _: 1 /* STABLE */
                                }, 8 /* PROPS */, ["label"]),
                                _createCommentVNode(" 금액 "),
                                _createVNode(_component_InputRow, {
                                    label: _ctx.$t(`${_ctx.tableLc}amount`),
                                    "is-required": "",
                                    "is-vertical-label": ""
                                }, {
                                    default: _withCtx(() => [
                                        _createVNode(_component_v_row, { "no-gutters": "" }, {
                                            default: _withCtx(() => [
                                                _createCommentVNode(" 관련 논의 슬랙: https://barogo.slack.com/archives/C02HKM628QK/p1681457087029599\n              TODO input combo의 경우 vuetify 기본 width와 figma width가 충돌이 나서 우선 금액 input에 음수값이 입력되는 버전으로 진행함 "),
                                                _createVNode(_component_v_col, { cols: "4" }, {
                                                    default: _withCtx(() => [
                                                        _createVNode(_component_v_autocomplete, {
                                                            "item-title": "text",
                                                            "item-value": "value",
                                                            modelValue: _ctx.amountType,
                                                            "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event) => ((_ctx.amountType) = $event)),
                                                            items: _ctx.amountTypeOptions,
                                                            variant: "outlined",
                                                            "hide-details": "auto",
                                                            class: "mr-2",
                                                            rules: _ctx.formRules.amountType,
                                                            onKeyup: _cache[8] || (_cache[8] = ($event) => ($event.stopPropagation()))
                                                        }, null, 8 /* PROPS */, ["modelValue", "items", "rules"])
                                                    ]),
                                                    _: 1 /* STABLE */
                                                }),
                                                _createVNode(_component_v_col, null, {
                                                    default: _withCtx(() => [
                                                        _createVNode(_component_v_text_field, {
                                                            modelValue: _ctx.amount,
                                                            "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event) => ((_ctx.amount) = $event)),
                                                            dense: "",
                                                            variant: "outlined",
                                                            "hide-details": "auto",
                                                            "validate-on": "blur",
                                                            inputmode: "numeric",
                                                            placeholder: _ctx.$t('common.input_field_placeholder', { field: '금액' }),
                                                            rules: _ctx.formRules.amount,
                                                            suffix: _ctx.$t('common.currency'),
                                                            oninput: "javascript: this.value = this.value.replace(/[^0-9]/g, '' );"
                                                        }, null, 8 /* PROPS */, ["modelValue", "placeholder", "rules", "suffix"])
                                                    ]),
                                                    _: 1 /* STABLE */
                                                })
                                            ]),
                                            _: 1 /* STABLE */
                                        })
                                    ]),
                                    _: 1 /* STABLE */
                                }, 8 /* PROPS */, ["label"]),
                                _createCommentVNode(" 메모 "),
                                _createVNode(_component_InputRow, {
                                    label: _ctx.$t(`${_ctx.tableLc}memo`),
                                    "is-vertical-label": ""
                                }, {
                                    default: _withCtx(() => [
                                        _createVNode(_component_v_text_field, {
                                            modelValue: _ctx.memo,
                                            "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event) => ((_ctx.memo) = $event)),
                                            dense: "",
                                            variant: "outlined",
                                            "hide-details": "auto",
                                            "validate-on": "blur",
                                            placeholder: _ctx.$t('common.input_field_placeholder', { field: '메모' }),
                                            maxlength: _ctx.CASH_AUTO_DEDUCT_GROUP_SCHEDULE_MEMO_MAX_LENGTH,
                                            onBlur: _ctx.onBlurMemoField
                                        }, null, 8 /* PROPS */, ["modelValue", "placeholder", "maxlength", "onBlur"])
                                    ]),
                                    _: 1 /* STABLE */
                                }, 8 /* PROPS */, ["label"])
                            ])
                        ])
                    ]),
                    _: 1 /* STABLE */
                }, 8 /* PROPS */, ["modelValue", "onSubmit"]),
                _createVNode(_component_v_divider),
                _createVNode(_component_DialogFooter, {
                    cancel: "",
                    ok: "",
                    "on-cancel": _ctx.handleClickCancel,
                    "on-ok": _ctx.handleClickOk
                }, null, 8 /* PROPS */, ["on-cancel", "on-ok"])
            ])
        ]),
        _: 1 /* STABLE */
    }, 8 /* PROPS */, ["modelValue", "onClick:outside", "onKeydown"]));
}
